export default {
  // 分享域名
  shareUrl: 'http://whgd.www168505.top/cultureAppH5/#',
  // shareUrl: 'http://whgd.www168505.top/cultureAppDemoH5/#',
  // shareUrl: 'http://localhost:8083/cultureAppH5/#',
}
